export const SKAG_CREDIT_APPLICATION_FAILURE_REASONS = {
    AUTH_ERROR: 'auth_error',
    DATA_ERROR: 'data_error',
    DATA_FORMAT_ERROR: 'data_format_error',
    NETWORK_ERROR: 'network_error',
    RETRIES_EXHAUSTED: 'retries_exhausted',
    SCORECARD_FAILED: 'scorecard_failed',
    X_API_KEY_ERROR: 'x_api_key_error',
} as const;

export const SKAG_CREDIT_APPLICATION_STATUSES = {
    FAILED: 'failed',
    IDLE: 'idle',
    IN_FLIGHT: 'in-flight',
    SUCCEEDED: 'succeeded',
} as const;

// Stable discriminators for 409 ConflictError messages. The backend prefixes
// the message with `<code>: ...`; the frontend matches the prefix instead of
// free-form English so wording changes can't silently break UX branching.
export const SKAG_CREDIT_APPLICATION_CONFLICT_CODES = {
    ALREADY_IN_FLIGHT: 'SKAG_ALREADY_IN_FLIGHT',
    ALREADY_TRANSMITTED: 'SKAG_ALREADY_TRANSMITTED',
    INTEGRATION_DISABLED: 'SKAG_INTEGRATION_DISABLED',
} as const;
